import { useState, useEffect } from "react";
import { useAdors } from "context/AdorsContext";
import { Modal, Card } from 'react-bootstrap';

export default function AdorElDeptAdrrList({ adorName }) {

  const handleImageError = (e) => {
    e.target.src = '/dist/img/noimages.png'; // Provide the path to your default or empty image
  };

  return (
    <div>

    </div>
  );
}
